import { IPendingCart } from 'models/cart/IPendingCart';

export interface ICreatePendingCart {
    portalId: string;
    companyId: string;
    employeeId: string;
    onsiteToken?: string;
    token: string;
}

export const createPendingCart = async ({
    portalId,
    companyId,
    employeeId,
    onsiteToken,
    token
}: ICreatePendingCart): Promise<IPendingCart> => {

    const body = {
        cancelUrl: (window as any).ENV.REACT_APP_DSP_PORTAL_HOME,
        successUrl: `${(window as any).ENV.REACT_APP_BASE_URL}/payment?success=true`,
        paymentProviderId: process.env.REACT_APP_PAYMENT_PROVIDER_ID
    };

    const options = {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
            'onsite_token': onsiteToken
        },
    } as RequestInit;

    return fetch(`/api/v1/worker/${employeeId}/portal/${portalId}/company/${companyId}/create-pending-card-payment?token=${token}`, options)
        .then(res => {
            if (res.ok) {
                // console.log('response', res);
                return res.json();
            } else {
                return {
                    errorCode: 'REQUEST_FAILED',
                    message: 'No Outstanding Purchases'
                };
            }
        })
        .catch(err => {
            console.log('Error completing purchase', err);
        });
};
